import _ from "lodash";
import DebugLogger from "../../../../utils/DebugLogger";
import DynamicServiceHelper from "./DynamicServiceHelper";
import HmacSHA1 from "crypto-js/hmac-sha1";
import MD5 from "crypto-js/md5";
import Base64 from "crypto-js/enc-base64";
import Constants from "../../../../config/Constants";

const TAG = "RNSpeechRecognize XFASR";
const HostUrl = "wss://rtasr.xfyun.cn/v1/ws";

export default class XunFeiASRSpeechRecognitionService {
    TIMEOUT_SECONDS = 180;

    appId = "";
    apiKey = "";
    punc = false;
    pd = "";
    useProxy = false;
    proxyAddress = "";
    lang = "";

    //for now it is generate by java code, if we use this, we should generate token in the server side.
    token = null;
    expireTime = 0;
    timestamp = 0;
    ws = null;
    resultText = "";

    streamSendingError = false;
    realTimeVoiceDataWriter = null;

    tmpReferenceText = null;
    tmpCallback = null;
    isRecording = false; // we will not throw exception/reject promise when recording for stream request
    buffer = null;

    constructor(configMap) {
        this.appKey = configMap.appKey;
        this.appId = configMap.appId;
        if (_.has(configMap, "punc")) {
            this.punc = configMap.punc === "1";
        }
        if (_.has(configMap, "pd")) {
            this.pd = configMap.pd;
        }
        if (_.has(configMap, "useProxy")) {
            this.useProxy = configMap.useProxy;
        }
        if (_.has(configMap, "proxyAddress")) {
            this.proxyAddress = configMap.proxyAddress;
        }

        if (_.has(configMap, "lang")) {
            this.lang = configMap.lang;
        }
    }

    Recognize(referenceText, wav, callback) {
        //start request.

        DebugLogger.log(TAG, "ajax call start");
        const requestUrl = this.GenerateUrl(HostUrl, this.appId, this.apiKey, this.punc, this.pd);
        const finalUrl = DynamicServiceHelper.GetUrl(requestUrl, 2, this.useProxy, this.proxyAddress);
        this.buffer = null;
        this.resultText = "";
        this.tmpCallback = callback;
        wav.arrayBuffer()
            .then(audioContent => {
                this.buffer = new Int8Array(audioContent, 44); //skip top 44 wav header;
                if ("WebSocket" in window) {
                    this.ws = new WebSocket(finalUrl);
                } else if ("MozWebSocket" in window) {
                    this.ws = new window.MozWebSocket(finalUrl);
                } else {
                    throw new Error("浏览器不支持WebSocket");
                }

                this.ws.onopen = e => {
                    setTimeout(() => {
                        this.wsOpened(e);
                    }, 500);
                    //this.config.onStart && this.config.onStart(e);
                };
                this.ws.onmessage = e => {
                    // this.config.onMessage && this.config.onMessage(e)
                    this.wsOnMessage(e);
                };
                this.ws.onerror = e => {
                    //this.stop();
                    DebugLogger.log("关闭连接ws.onerror");
                    //this.config.onError && this.config.onError(e);
                    callback.onFailure("Error", e != null ? e.message : "connect fail");
                };
                this.ws.onclose = e => {
                    //this.stop();
                    DebugLogger.log("关闭连接ws.onclose");
                    //this.config.onClose && this.config.onClose(e);
                };
            })
            .catch(err => {
                DebugLogger.log("_postFileApi err", err);
                callback.onFailure("Error", err.message);
            });
    }

    BeforeSendVoiceData(referenceText, callback) {
        throw new Error("recognize with record is not supported");
    }

    SendVoiceData(voiceData, offset, length) {
        //if error in stream request, we just do not send anymore
        if (this.realTimeVoiceDataWriter != null && !this.streamSendingError) {
            try {
                this.realTimeVoiceDataWriter.write(voiceData, offset, length);
            } catch (ex) {
                this.streamSendingError = true;
                DebugLogger.log(TAG, "SendVoiceData Error:");
                DebugLogger.log(TAG, ex.message);
            }
        }
    }

    AfterSendVoiceData(wav) {
        this.isRecording = false;
        DebugLogger.log(TAG, "AfterSendVoiceData");
        if (this.realTimeVoiceDataWriter != null && !this.streamSendingError) {
            DebugLogger.log(TAG, "AfterSendVoiceData Normal Case");
            this.realTimeVoiceDataWriter.stop();
            this.realTimeVoiceDataWriter = null;
        } else {
            DebugLogger.log(TAG, "AfterSendVoiceData Bad Case");
            this.Recognize(this.tmpReferenceText, wav, this.tmpCallback);
        }
    }

    IsErrorWhenSendingStream() {
        return this.streamSendingError;
    }

    NeedSendWavHeaderInNetworkStream() {
        return true;
    }

    destroy() {
        //nothing to do
        this.ws.close(1000);
    }

    GenerateUrl(hostUrl, appId, apiKey, punc, pd) {
        let request = hostUrl;

        const ts = Math.floor(new Date().getTime() / 1000); //new Date().getTime()/1000+'';
        const signa = MD5(appId + ts); //hex_md5(encodeURIComponent(appId + ts));//EncryptUtil.HmacSHA1Encrypt(EncryptUtil.MD5(appId + ts), secretKey);
        const signatureSha = HmacSHA1(signa.toString(), apiKey);
        let signature = Base64.stringify(signatureSha);
        signature = encodeURIComponent(signature);
        request = request + "?appid=" + appId + "&ts=" + ts + "&signa=" + signature;
        if (punc) {
            request += "&punc=0";
        }
        if (pd != null && !_.isEmpty(pd)) {
            request += "&pd=" + encodeURIComponent(pd);
        }
        const langCode = this.lang === Constants.SPEECH_LANG.en ? "en" : "";
        if (langCode !== ""){
            request += "&lang=" + encodeURIComponent(langCode);
        }
        return request;
    }

    wsOpened() {
        if (this.ws.readyState !== 1) {
            return;
        }

        const chunkSize = 1280 * 5;
        let currentArrayIndex = 0;
        const audioData = this.buffer.slice(currentArrayIndex, currentArrayIndex + chunkSize);
        currentArrayIndex += chunkSize;
        this.ws.send(new Int8Array(audioData));
        this.handlerInterval = setInterval(() => {
            // websocket未连接
            if (this.ws.readyState !== 1) {
                clearInterval(this.handlerInterval);
                return;
            }
            if (this.buffer.length <= currentArrayIndex) {
                this.ws.send('{"end": true}');
                DebugLogger.log("发送结束标识");
                clearInterval(this.handlerInterval);
                return false;
            }
            const audioData2 = this.buffer.slice(currentArrayIndex, currentArrayIndex + chunkSize);
            currentArrayIndex += chunkSize;
            if (audioData2.length > 0) {
                this.ws.send(new Int8Array(audioData2));
            }
        }, 40);
    }

    wsOnMessage(e) {
        let jsonData = JSON.parse(e.data);
        if (jsonData.action === "started") {
            // 握手成功
            DebugLogger.log("握手成功");
        } else if (jsonData.action === "result") {
            // 转写结果
            // if (this.config.onMessage && typeof this.config.onMessage == "function") {
            //     this.config.onMessage(jsonData.data);
            // }
            const result = this.getContent(jsonData.data);
            this.resultText += result;
            //中间结果 messageObj.ls=false, 最终结果ls=true.
            if (_.isEqual("true", jsonData.data.ls) && this.tmpCallback != null) {
                this.tmpCallback.onSuccess("", this.resultText);
                this.tmpCallback = null;
                DebugLogger.log(TAG, "sid:" + jsonData.data.sid + " 最终识别结果: " + this.resultText);
                this.resultText = "";
            }
            DebugLogger.log(TAG, "ws:" + e.data);
            DebugLogger.log(TAG, "sid:" + jsonData.data.sid + " 中间结果: " + result);
        } else if (jsonData.action === "error") {
            // 连接发生错误
            DebugLogger.log("出错了:", jsonData);
        }
    }

    ArrayBufferToBase64(buffer) {
        let binary = "";
        const bytes = new Uint8Array(buffer);
        const len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    getContent(data) {
        let tmpResult = "";
        if (data.cn.st.type === 0) {
            data.cn.st.rt.forEach(j => {
                j.ws.forEach(k => {
                    k.cw.forEach(l => {
                        tmpResult += l.w;
                    });
                });
            });
        }
        return tmpResult;
    }
}
